import { render, staticRenderFns } from "./RotatingGroupsExtension.vue?vue&type=template&id=9d9d74f0&scoped=true&"
import script from "./RotatingGroupsExtension.vue?vue&type=script&lang=js&"
export * from "./RotatingGroupsExtension.vue?vue&type=script&lang=js&"
import style0 from "./RotatingGroupsExtension.vue?vue&type=style&index=0&id=9d9d74f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9d74f0",
  null
  
)

export default component.exports